import { Component } from '@angular/core';

@Component({
  selector: 'app-product-stock-detail',
  standalone: false,
  templateUrl: './product-stock-detail.component.html',
  styleUrl: './product-stock-detail.component.scss',
})
export class ProductStockDetailComponent {}
